// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { Checkbox, Dropdown } from "semantic-ui-react";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const SectionFilter = ({ title = "", isChecked = false, options, value, onChangeCheck, onChangeDropdown }) => {
	return (
		<>
			<div className={styles.sectionContainer}>
				<Checkbox className={styles.checkBox} checked={isChecked} onChange={onChangeCheck} />
				<Text className={styles.sectionTitle}>{title}</Text>
			</div>
			<div className={styles.dropdownContainer}>
				<Dropdown
					fluid
					multiple
					search
					clearable
					className={styles.dropdown}
					placeholder={title}
					value={value}
					options={options}
					onChange={onChangeDropdown}
				/>
			</div>
		</>
	);
};

SectionFilter.propTypes = {
	title: PropTypes.string.isRequired,
	isChecked: PropTypes.bool.isRequired,
	options: PropTypes.array.isRequired,
	value: PropTypes.array,
	onChangeCheck: PropTypes.func,
	onChangeDropdown: PropTypes.func,
};

export default SectionFilter;
